import React from 'react'
import styles from './Legend.module.css'
import Info from './Info'
import YearChange from './YearChange'

export default ({
  fieldDefinition,
  children,
  location,
  withoutInfo = false,
}) => (
  <div>
    <h3 className={styles.title}>
      {fieldDefinition.label}
      {!withoutInfo ? <Info location={location} /> : ''}
    </h3>
    {location && location.match('.*Tagesoeffnungszeiten') ? (
      <span style={{ fontWeight: 'bold' }}>
        Öffnungszeiten durchgehend von Montag bis Donnerstag
      </span>
    ) : null}
    {location && location.match('.*Schliesstage') ? (
      <span style={{ fontWeight: 'bold' }}>geschlossene Betriebstage</span>
    ) : null}
    {location && location.match('Anteil_*') ? (
      <span style={{ fontWeight: 'bold' }}>Anteil in %</span>
    ) : null}
    <div className={styles.legendContainer}>
      <ul className={styles.legend}>
        {Object.values(fieldDefinition.values)
          .sort((a, b) => a.order - b.order)
          .map((v, i) => (
            <li key={i}>
              <svg
                className={styles.color}
                style={{
                  border: '1px solid black',
                }}
              >
                <rect
                  width="16"
                  height="10"
                  style={{
                    fill: v.color,
                  }}
                />
              </svg>
              <span className="label">{v.label}</span>
            </li>
          ))}
      </ul>
      {children}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Legend.js